import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthGuard = ({ children }) => {

    const account = useSelector((state) => state.account);

    const { isLoggedIn, data } = account;

    if (!isLoggedIn || !data) {
        return <Navigate to="/auth/signin" />;
    }

    return children;
};

export default AuthGuard;